import StorageOutlinedIcon from '@material-ui/icons/StorageOutlined';
import { emptyPlaceholderStyle } from './EmptyPlaceholderStyle';

const EmptyPlaceholder = ({ text = 'No Results', className, icon }) => {
    const classes = emptyPlaceholderStyle();

    return (
        <div className={`${className} ${classes.wrapper}`} elevation={1}>
            {icon ? icon : <StorageOutlinedIcon className={classes.icon} />}
            <div>{text}</div>
        </div>
    )
}

export default EmptyPlaceholder
